import type { SentidoAjusteCredito, TipoAjusteCredito } from './facturaFormTypes';

export function metodoPagoEsCreditoSistema(metodoPago: string | undefined | null): boolean {
  const s = String(metodoPago ?? '');
  return s === '__clientelo_credito__' || s === '__credito__';
}

/** COP firmado: negativo = descuento, positivo = recargo. */
export function copAjusteCredito(
  baseTotal: number,
  tipo: TipoAjusteCredito,
  valor: number,
  sentido: SentidoAjusteCredito
): number {
  const base = Math.max(0, Math.round(Number(baseTotal) || 0));
  const v = Math.max(0, Number(valor) || 0);
  if (!tipo || tipo === 'ninguno' || v === 0 || base <= 0) return 0;
  const mag =
    tipo === 'porcentaje' ? Math.round(base * (v / 100)) : Math.round(v);
  if (sentido === 'descuento') return -Math.min(Math.max(0, mag), base);
  return Math.max(0, mag);
}

export function aplicarAjusteCreditoAlTotal(
  baseTotal: number,
  opts: {
    aplicar: boolean;
    tipo: TipoAjusteCredito;
    valor: number;
    sentido: SentidoAjusteCredito;
  }
): { ajuste: number; total: number } {
  const base = Math.max(0, Math.round(Number(baseTotal) || 0));
  if (!opts.aplicar) return { ajuste: 0, total: base };
  const ajuste = copAjusteCredito(base, opts.tipo, opts.valor, opts.sentido);
  return { ajuste, total: Math.max(0, base + ajuste) };
}

export function textoAjusteCredito(opts: {
  tipo?: TipoAjusteCredito;
  valor?: number;
  sentido?: SentidoAjusteCredito;
  ajusteCop: number;
}): string | null {
  if (!opts.ajusteCop) return null;
  const fmt = (n: number) => `$${Math.abs(Math.round(n)).toLocaleString('es-CO')}`;
  const verbo = opts.sentido === 'recargo' ? 'recargo' : 'descuento';
  const sign = opts.ajusteCop > 0 ? '+' : '−';
  if (opts.tipo === 'porcentaje') {
    return `Ajuste crédito: ${verbo} ${opts.valor}% (${sign}${fmt(opts.ajusteCop)})`;
  }
  return `Ajuste crédito: ${verbo} ${sign}${fmt(opts.ajusteCop)}`;
}

/** Descuento de productos + descuento de crédito (el recargo no entra aquí). */
export function descuentosParaPersistir(totales: {
  descuento: number;
  ajuste_credito?: number;
}): number {
  const extra = Math.max(0, -(Number(totales.ajuste_credito) || 0));
  return Math.max(0, Math.round((Number(totales.descuento) || 0) + extra));
}

export function notasConAjusteCredito(
  notas: string | undefined,
  texto: string | null
): string {
  const base = String(notas || '').trim();
  if (!texto) return base;
  if (base.includes(texto)) return base;
  return base ? `${base}\n${texto}` : texto;
}
